import { Controller } from "stimulus";

export default class extends Controller {
  fire(e) {
    const { event } = e.currentTarget.dataset;

    window.dispatchEvent(new CustomEvent(event));
  }
}
